// extracted by mini-css-extract-plugin
export default {"section__header":"ProfileSection_section__header__IH26L"};